$(document).ready(function() {
    // Set how many items to show by default
    let itemsToShow = 3;

    // Hide all items beyond the set number
    $('.wrap-items .item').slice(itemsToShow).hide();

    // If there are more than 'itemsToShow', show the "Load More" button
    if ($('.wrap-items .item').length > itemsToShow) {
        $('#loadMore').addClass('active');
    } else {
        $('#loadMore').removeClass('active');
    }

    // When "Load More" is clicked, show the rest of the items
    $('#loadMore').on('click', function(e) {
        e.preventDefault();
        $('.wrap-items .item:hidden').slideDown(); // Show hidden items
        $(this).hide(); // Hide the "Load More" button once all items are visible
    });
});
